// extracted by mini-css-extract-plugin
export default {"container":"loading_container__RytLp","title":"loading_title__jpBt7"};